import { syncAllDataForConfiguration, syncAllXeroData } from 'services/XeroService'
import { Success, Error } from 'utils/alerts'

/**
 * Handle syncing all data for a specific configuration
 * @param {Object} xeroConfig - Xero configuration object
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} getCustomers - Action to get customers
 * @param {Function} getAccountCodes - Action to get account codes
 */
export const handleSyncAllData = (xeroConfig, dispatch, getCustomers, getAccountCodes) => {
    if (!xeroConfig) {
        Error('Please select a Xero configuration first')
        return
    }

    // Show loading state
    const configId = xeroConfig.id
    const configName = xeroConfig.name || 'Selected configuration'

    // Call the sync API
    syncAllDataForConfiguration(configId)
        .then(response => {
            if (response.data.success) {
                Success(`Data sync initiated for ${configName}`)
                // Refresh customers and account codes after a delay
                setTimeout(() => {
                    dispatch(getCustomers({ configurationId: configId }))
                    dispatch(getAccountCodes({ configurationId: configId }))
                }, 2000) // 2 second delay to allow sync to start
            } else {
                Error(response.data.message || 'Failed to sync data')
            }
        })
        .catch(err => {
            console.error('Sync error:', err)
            Error('Error syncing data: ' + (err.message || 'Unknown error'))
        })
}

/**
 * Handle refreshing data for a company
 * @param {Object} selectedCompany - Selected company object
 * @param {Object} globalCompany - Global company from navbar
 * @param {Object} xeroConfig - Xero configuration object
 * @param {Function} setSyncing - State setter for syncing status
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} getCustomers - Action to get customers
 * @param {Function} getAccountCodes - Action to get account codes
 */
export const handleRefreshData = (
    selectedCompany,
    globalCompany,
    xeroConfig,
    setSyncing,
    dispatch,
    getCustomers,
    getAccountCodes
) => {
    // Check both selectedCompany and globalCompany
    if (!selectedCompany && !globalCompany) {
        Error('Please select a company first')
        return
    }

    // Use whichever company is available
    const companyToUse = selectedCompany || globalCompany

    setSyncing(true)

    // Call the sync all data task for the company
    syncAllXeroData(companyToUse.id)
        .then(response => {
            if (response.data.success) {
                Success(`Full data sync initiated for ${companyToUse.name}`)
                // Refresh customers and account codes after a delay
                setTimeout(() => {
                    if (xeroConfig) {
                        dispatch(getCustomers({ configurationId: xeroConfig.id }))
                        dispatch(getAccountCodes({ configurationId: xeroConfig.id }))
                    } else {
                        dispatch(getCustomers({ companyId: companyToUse.id }))
                        dispatch(getAccountCodes({ companyId: companyToUse.id }))
                    }
                }, 2000) // 2 second delay to allow sync to start
            } else {
                Error(response.data.message || 'Failed to sync data')
            }
        })
        .catch(err => {
            console.error('Sync error:', err)
            Error('Error syncing data: ' + (err.message || 'Unknown error'))
        })
        .finally(() => {
            setSyncing(false)
        })
}
